export default "__VITE_ASSET__CEFrcYA0__"